import { useContext, useEffect } from 'react'
import { LayoutContext } from '../../../context/layout-context'

export const useHeaderMobile = () => {
  const {
    layoutState: { isOrderDetailsMobileShow },
    setLayoutState,
  } = useContext(LayoutContext)

  useEffect(() => {
    if (isOrderDetailsMobileShow) {
      window.document.body.classList.add('no-scroll')
    } else {
      window.document.body.classList.remove('no-scroll')
    }
  }, [isOrderDetailsMobileShow])

  const openOrderDetailsMobile = () => {
    setLayoutState({ isOrderDetailsMobileShow: true })
  }

  const closeOrderDetailsMobile = () => {
    setLayoutState({ isOrderDetailsMobileShow: false })
  }

  return {
    isOrderDetailsMobileShow,
    openOrderDetailsMobile,
    closeOrderDetailsMobile,
  }
}
